import React from "react";

const Card = ({icon, title, content}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg py-4 px-8 mr-10 lg:mr-24 flex justify-content-center align-content-center flex-col text-center">
        <div className="text-primary flex m-auto mb-2">{icon}</div>
      
      <h3 className="text-black font-bold">{title}</h3>
      <p className="text-black">{content}</p>
    </div>
  );
};

export default Card;
